var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamCapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 17059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5818",
    d: "M34.9191 0.000523822H5.10768C3.75304 0.000523822 2.45388 0.532135 1.496 1.4784C0.538128 2.42467 0 3.70809 0 5.04632C0 6.38454 0.538128 7.66796 1.496 8.61423C2.45388 9.5605 3.75304 10.0921 5.10768 10.0921H34.9191C35.5881 10.0906 36.2503 9.95891 36.8677 9.70447C37.4852 9.45004 38.0458 9.07788 38.5176 8.60927C38.9894 8.14066 39.363 7.58478 39.6172 6.97343C39.8714 6.36208 40.0011 5.70723 39.999 5.04632C40.0124 4.38237 39.8904 3.72254 39.6403 3.10615C39.3901 2.48977 39.0169 1.92945 38.5428 1.4586C38.0688 0.98774 37.5036 0.615984 36.8811 0.365482C36.2585 0.11498 35.5912 -0.00913927 34.9191 0.000523822Z",
    fill: "url(#paint0_linear_437_21206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5819",
    d: "M30.2412 12.6127H9.78765C8.86081 12.6127 7.97192 12.9765 7.31654 13.6239C6.66116 14.2714 6.29297 15.1495 6.29297 16.0651C6.29297 16.9807 6.66116 17.8588 7.31654 18.5063C7.97192 19.1537 8.86081 19.5174 9.78765 19.5174H30.2412C30.6998 19.5194 31.1541 19.4313 31.5779 19.2583C32.0017 19.0853 32.3864 18.8309 32.7098 18.5097C33.0332 18.1886 33.2888 17.8072 33.4617 17.3877C33.6347 16.9681 33.7215 16.5189 33.7171 16.0659C33.7332 15.6098 33.6544 15.1553 33.4857 14.7304C33.3169 14.3056 33.0618 13.9194 32.736 13.5958C32.4103 13.2722 32.0208 13.018 31.5918 12.8489C31.1627 12.6798 30.703 12.5995 30.2412 12.6127Z",
    fill: "url(#paint1_linear_437_21206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 806",
    d: "M20.0813 32C23.1088 32 25.5631 29.5625 25.5631 26.5557C25.5631 23.5489 23.1088 21.1113 20.0813 21.1113C17.0539 21.1113 14.5996 23.5489 14.5996 26.5557C14.5996 29.5625 17.0539 32 20.0813 32Z",
    fill: "url(#paint2_linear_437_21206)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_21206",
    x1: 20.04,
    y1: -10.5765,
    x2: 20.04,
    y2: 32.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#4000BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_21206",
    x1: 20.0335,
    y1: -10.5864,
    x2: 20.0335,
    y2: 29.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4000BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_21206",
    x1: 20.0594,
    y1: -10.5857,
    x2: 20.0594,
    y2: 29.1908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4000BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BACF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCapIcon);
export default __webpack_public_path__ + "static/media/team_cap_icon.78d0cd0a4d7bba17c139c51fa269085d.svg";
export { ForwardRef as ReactComponent };